module.exports = __webpack_public_path__ + "images/collections/business-class-feature-roadmap.04c368f4479f478b6705.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/collections/business-class-feature-roadmap.png
// module id = ay20
// module chunks = 24